export default __webpack_public_path__ + "static/media/christmasLogo.38853da2.svg";